<script>
import Component from '~/sites/shop/pages/contact/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/kontakt',
      de: '/impressum',
      en: '/contact',
      sk: '/kontakt',
    },
  },
}
</script>
